module.exports = __webpack_public_path__ + "static/video-850a0e2c58e4a020e3ef681e35a1c313.png";